import Seo from "@/components/Seo";
import { useLang, route } from "../i18n";
import { COMPANY } from "../data/config";
import PageHero from "../components/PageHero";
import { Reveal } from "../components/Reveal";

// Legal pages: privacy, terms, accessibility, editorial policy, disclosures.
const Legal = ({ doc }) => {
  const { lang, t } = useLang();
  const d = t.legal[doc];

  return (
    <>
      <Seo title={`${d.title} | ${COMPANY.name}`} siteName={COMPANY.name} description={d.sections[0].p[0]} />
      <PageHero
        eyebrow={t.footer.legal}
        lines={[d.title]}
        breadcrumb={[{ label: t.nav.home, to: route(lang, "home") }, { label: d.title }]}
        testid={`legal-${doc}`}
      />
      <section className="bg-[#F4F0E8]">
        <div className="mx-auto max-w-3xl px-5 py-16 sm:px-8 sm:py-24">
          <p className="text-[0.65rem] uppercase tracking-[0.18em] text-[#171717]/45">{t.legal.updated}</p>
          <div className="mt-10 space-y-10">
            {d.sections.map((sec, i) => (
              <Reveal key={i} delay={i * 0.04}>
                <h2 className="text-lg font-normal tracking-tight text-[#171717]">{sec.h}</h2>
                {sec.p.map((para, j) => (
                  <p key={j} className="mt-3 text-sm leading-relaxed text-[#171717]/70">
                    {para}
                  </p>
                ))}
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Legal;
